module.exports = __webpack_public_path__ + "img/image-commitment.893dd4b5.jpg";